<template>
  <div class="store-header">
    <p style="font-size: 24px; font-weight: 800;">ロボストア</p>
    <p class="left-title logo">
      <img src="@/assets/logo.svg" style="height: 60px; width: auto; object-fit: cover;"/>
    </p>
    <div class="accout-box">
      <button class="button is-small" @click="isModal=true" style="margin-right: 16px;" v-if="user.isAgent">ストアカテゴリ編集</button>
      <img class="img-icon" :src="user.profileIcon"/>
    </div>
    <!-- モーダル START -->
    <b-modal width="680px" :active.sync="isModal">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <div class="cover-filter">
            <p class="card-header-title title">
              カテゴリ編集
            </p>
          </div>
        </header>
        <div class="card-content parent-box">
          <table class="store-table" v-if="storeCategory.length > 0" style="overflow: scroll;">
            <tr>
              <th v-for="(t, i) in tableHeader" :key="i">{{t}}</th>
            </tr>
            <tr v-for="(s, index) in storeCategory" :key="index">
              <td><b-numberinput style="width: 100px;" size="is-small" v-model="s.order" min="1" :max="storeCategory.length + 1"></b-numberinput></td>
              <td>
                <b-select size="is-small" v-model="s.category_type" placeholder="タブの種類">
                  <option v-for="(t, idx) in tabs" :value="idx" :key="idx">
                    {{ t }}
                  </option>
                </b-select>
              </td>
              <td><input class="input is-small" v-model="s.category_name"/></td>
              <td><input class="input is-small" v-model="s.category_title"/></td>
              <td><input class="input is-small" v-model="s.category_desc"/></td>
              <td><button class="button is-small" @click="$store.dispatch('auth/deleteStoreCateogry', s.category_id)">×</button></td>
            </tr>
          </table>
          <button class="button is-small is-fullwidth is-primary" @click="$store.dispatch('auth/putStoreCateogry', storeCategory)">保存</button>
          <hr>
          <div class="post-form">
            <p style="font-weight: 600;">カテゴリの新規投稿</p>
            <div>
              <p>タブ</p>
              <b-select size="is-small" v-model="inputs.category_type" placeholder="タブの種類">
                <option v-for="(t, idx) in tabs" :value="idx" :key="idx">
                  {{ t }}
                </option>
              </b-select>
            </div>
            <div>
              <p>カテゴリ名</p>
              <input class="input is-small" v-model="inputs.category_name"/>
            </div>
            <div>
              <p>タイトル</p>
              <input class="input is-small" v-model="inputs.category_title"/>
            </div>
            <div>
              <p>詳細</p>
              <input class="input is-small" v-model="inputs.category_desc"/>
            </div>
            <div>
              <p>順番</p>
              <b-numberinput style="width: 100px;" size="is-small" v-model="inputs.order" min="1" :max="storeCategory.length + 1"></b-numberinput>
            </div>
            <button class="button is-small" @click="$store.dispatch('auth/postStoreCateogry', inputs)">新規カテゴリを追加</button>
          </div>
          <hr>
          <div class="switch-form">
            <p style="font-size: smaller; font-weight: 600;">未分類の表示可否</p>
            <button @click="$store.dispatch('auth/setProfile', {data: {'is_store_other': false}, type: 'user'})" class="button is-small" style="width: 100px;" v-if="user.isStoreOther">表示しない</button>
            <button @click="$store.dispatch('auth/setProfile', {data: {'is_store_other': true},  type: 'user'})" class="button is-small" style="width: 100px;" v-if="!user.isStoreOther">表示する</button>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- モーダル END -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'StoreHeader',
  componentName: 'StoreHeader',
  computed: {
    ...mapState('auth', ['user', 'storeCategory']),
    ...mapState('chatbot', ['stores'])
  },
  data () {
    return {
      isModal: false,
      tabs: ['ホームページ設置用', '応募後対応'],
      tableHeader: ['順番', 'タブ', 'カテゴリ名', 'タイトル', '詳細', '削除'],
      inputs: {
        category_type  : 0,
        category_name  : '',
        category_title : '',
        order          : 0
      }
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.store-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  width: 100%;
  padding-left: 20px;
  padding-right: 20px;
  background: rgba(0, 0, 0, 0.8);
  color: white;
}
.logo {
  position: absolute;
  left: calc(50% - 100px);
  width: 200px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.left-title {
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
}
.chara {
  margin-top: 5px;
  margin-left: 15px;
}
.accout-box {
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.img-icon {
  width:  60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
  border: solid thin #ccc;
  background: white;
}
.parent-box {
  display: flex;
  justify-content: space-around;
  padding: 16px;
  flex-wrap: wrap;
}
.box-request {
  width: 100%;
  height: auto;
  padding: 20px;
  font-size: 15px;
  text-align: left;
}
.store-table {
  display: block;
  height: 100%;
  width: 100%;
  overflow: scroll;
}
.store-table::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  visibility: hidden;
}
table td:not([align]), table th:not([align]) {
  text-align: center;
}
table {
  width: 100%;
  border-collapse:collapse;
  margin: 0 auto;
}
td,th {
  padding:10px;
  margin: auto;
  max-width: 350px;
  font-size: smaller;
}
td {
  text-align: left;
}
th {
  color:#fff;
  background:#AA0066;
}
table tr:nth-child(odd) {
  background:#ffeeff;
}
table tr:nth-child(even) {
  background:#fafafa;
}
.post-form {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  padding: 8px;
  background: #f0e0f0;
}
.post-form > div {
  display: flex;
  width: 100%;
  margin: 8px;
}
.post-form > div > p {
  display: flex;
  width: 100px;
  font-weight: 600;
  font-size: smaller;
}
.post-form > div > input {
  width: 200px;
}
.switch-form {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  text-align: left;
  width: 100%;
  padding: 8px;
  background: #e0e0f0;
}
</style>



// WEBPACK FOOTER //
// src/views/Store/StoreHeader.vue